import { apiRequest } from './client';
import type { Conversation, Message, PreferredFormat, SendMessageResponse } from '../types/api';

export const conversationsApi = {
  list: () => apiRequest<{ conversations: Conversation[] }>('/conversations'),

  create: (personaId = 'cfo', title?: string) =>
    apiRequest<{ conversation: Conversation }>('/conversations', {
      method: 'POST',
      body: { personaId, title },
    }),

  get: (id: string) =>
    apiRequest<{ conversation: Conversation; messages: Message[] }>(`/conversations/${id}`),

  delete: (id: string) =>
    apiRequest<{ ok: true }>(`/conversations/${id}`, { method: 'DELETE' }),

  patch: (id: string, fields: { title?: string; pinned?: boolean }) =>
    apiRequest<{ conversation: Conversation }>(`/conversations/${id}`, {
      method: 'PATCH',
      body: fields,
    }),

  sendMessage: (id: string, content: string, preferredFormat: PreferredFormat = 'auto') =>
    apiRequest<SendMessageResponse>(`/conversations/${id}/messages`, {
      method: 'POST',
      body: { content, preferred_format: preferredFormat },
    }),

  regenerate: (id: string, msgId: string, opts: { content?: string; preferredFormat?: PreferredFormat } = {}) =>
    apiRequest<{ assistantMessage: Message }>(
      `/conversations/${id}/messages/${msgId}/regenerate`,
      {
        method: 'POST',
        body: { content: opts.content, preferred_format: opts.preferredFormat },
      },
    ),
};
